exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn.btn-credit{background:#dcdcdc;color:#000}button.btn.btn-credit.active{background-color:#fa2837!important;color:#fff}", ""]);

// exports
